import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthProvider'
import Layout from './components/Layout/Layout'
import './App.css'
import { Suspense, lazy } from 'react'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import ErrorScreen from './components/ErrorScreen/ErrorScreen'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import { useNotifications } from './hooks/useNotifications'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const LandingPage = lazy(() => import('./pages/LandingPage/LandingPage'))
const Notification = lazy(() => import('./pages/Notification'))
const ProtectedChat = lazy(() => import('./components/Protected/ProtectedChat'))
const TermsOfService = lazy(
  () => import('./pages/TermsOfService/TermsOfService')
)
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy/PrivacyPolicy'))
const EmailVerificationHandler = lazy(
  () => import('./components/Auth/EmailVerificationHandler')
)
const ForgotPassword = lazy(() => import('./components/Auth/ForgotPassword'))
const ChangePasswordForm = lazy(
  () => import('./components/Auth/ChangePasswordForm')
)

function App() {
  useNotifications()

  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorBoundary fallback={<ErrorScreen />}>
          {/* Properly configured ToastContainer */}
          <ToastContainer
            position='top-right'
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='light'
          />
          <Suspense
            fallback={
              <div className='loader-container'>
                <div className='loader'></div>
              </div>
            }
          >
            <Routes>
              <Route element={<Layout />}>
                <Route path='/' element={<LandingPage />} />
                <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                <Route path='/notification' element={<Notification />} />
                <Route path='/terms-of-service' element={<TermsOfService />} />
                <Route path='/forgot-password' element={<ForgotPassword />} />

                {/* Protected Routes */}
                <Route path='/chat' element={<ProtectedChat />} />
                <Route element={<ProtectedRoute />}>
                  <Route
                    path='/change-password'
                    element={<ChangePasswordForm />}
                  />
                </Route>
              </Route>
              <Route path='/auth' element={<EmailVerificationHandler />} />
              <Route path='*' element={<Navigate to='/' replace />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
